class ShopifyCartDetector {
  constructor(options = {}) {
    this.options = {
      targetSelector: '.mobile-cart-count',
      updateText: 'Cart Updated!',
      resetDelay: 3000,
      onCartUpdate: null,
      ...options
    };
    
    this.originalText = null;
    this.init();
  }

  init() {
    this.interceptFetch();
    this.interceptXHR();
    this.interceptJQuery();
  }

  isCartEndpoint(url) {
    const endpoints = ['/cart/add.js', '/cart/change.js', '/cart/update.js', '/cart/update', '/cart/change', '/cart/add'];
    return endpoints.some(endpoint => url.includes(endpoint));
  }

  handleCartUpdate(url, response = null) {
    // console.log('Cart updated via:', url);
    
    // Custom callback
    if (this.options.onCartUpdate) {
      this.options.onCartUpdate(url, response);
    }
    
    // Update target element
    this.updateElement();
    
    // Dispatch custom event
    window.dispatchEvent(new CustomEvent('shopifyCartUpdated', {
      detail: { url, response }
    }));
  }

  updateElement() {
    const element = document.querySelector(this.options.targetSelector);
    if (!element) return;

    if (this.originalText === null) {
      this.originalText = element.textContent;
    }

    element.textContent = this.options.updateText;

    if (this.options.resetDelay > 0) {
      setTimeout(() => {
       element.textContent = this.originalText;
      }, this.options.resetDelay);
    }
  }

  interceptFetch() {
    const originalFetch = window.fetch;
    const self = this;

    window.fetch = function(url, options = {}) {
      if (self.isCartEndpoint(url)) {
        return originalFetch(url, options)
          .then(response => {
            if (response.ok) {
              response.clone().json().then(data => {
                self.handleCartUpdate(url, data);
              }).catch(() => {
                self.handleCartUpdate(url);
              });
            }
            return response;
          });
      }
      return originalFetch(url, options);
    };
  }

  interceptXHR() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    const self = this;

    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this._cartUrl = url;
      return originalOpen.apply(this, [method, url, ...args]);
    };

    XMLHttpRequest.prototype.send = function(data) {
      if (self.isCartEndpoint(this._cartUrl)) {
        this.addEventListener('load', function() {
          if (this.status >= 200 && this.status < 300) {
            try {
              const response = JSON.parse(this.responseText);
              self.handleCartUpdate(this._cartUrl, response);
            } catch (e) {
              self.handleCartUpdate(this._cartUrl);
            }
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  interceptJQuery() {
    if (typeof jQuery !== 'undefined') {
      const self = this;
      jQuery(document).ajaxSuccess(function(event, xhr, settings) {
        if (self.isCartEndpoint(settings.url)) {
          try {
            const response = JSON.parse(xhr.responseText);
            self.handleCartUpdate(settings.url, response);
          } catch (e) {
            self.handleCartUpdate(settings.url);
          }
        }
      });
    }
  }
}